// extracted by mini-css-extract-plugin
    if(module.hot) {
      // 1732202772803
      var cssReload = require("/Users/dres/AMP/mada-app/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  